import { BaseComponent } from 'src/scripts/components/base-component'
import { BottomSheet } from 'src/scripts/components/bottom-sheet'
import { ShippingCalculator } from 'src/scripts/components/shipping-calculator'
import { $el, $list } from 'src/scripts/utils/utils'
import { CartNote } from './cart-note'

const SELECTOR_ORDER_NOTE_BUTTON = '.cart-order-notes__button[data-order-note]'
const SELECTOR_SHIPPING_CALCULATOR_BUTTON =
  '.cart-order-notes__button[data-shipping-calculator]'
const SELECTOR_ORDER_NOTE_BOTTOM_SHEET = '.bottom-sheet:has(.cart-note)'
const SELECTOR_SHIPPING_CALCULATOR_BOTTOM_SHEET =
  '.bottom-sheet:has(.shipping-calculator)'
const SELECTOR_CONTENT_CHILDREN = '.cart-order-notes__content > *'
const SELECTOR_ORDER_NOTE = '.cart-note'
const SELECTOR_SHIPPING_CALCULATOR = '.shipping-calculator'
const CLASS_ORDER_NOTE_OPENED = 'cart-order-notes--order-note-opened'
const CLASS_SHIPPING_CALCULATOR_OPENED =
  'cart-order-notes--shipping-calculator-opened'

export class CartOrderNotes extends BaseComponent {
  resizeObserver: ResizeObserver

  mountComponent(): void {
    super.mountComponent()

    this.resizeObserver = new ResizeObserver(this.handleResize)

    this.addListener(this, 'click', this.handleClick)

    $list(SELECTOR_CONTENT_CHILDREN, this).forEach(el =>
      this.resizeObserver.observe(el),
    )
  }

  unmountComponent(): void {
    super.unmountComponent()

    this.removeListener(this, 'click', this.handleClick)
    this.resizeObserver.disconnect()
  }

  handleResize = (entities: ResizeObserverEntry[]) => {
    entities.forEach(entity => {
      const { target } = entity

      if (target instanceof ShippingCalculator) {
        this.style.setProperty(
          '--shipping-calculator-height',
          `${entity.target.scrollHeight}px`,
        )
      } else if (target instanceof CartNote) {
        this.style.setProperty(
          '--order-note-height',
          `${entity.target.scrollHeight}px`,
        )
      }
    })
  }

  handleClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement

    if (target.closest(SELECTOR_ORDER_NOTE_BUTTON)) {
      this.handleOrderNoteButtonClick()
    } else if (target.closest(SELECTOR_SHIPPING_CALCULATOR_BUTTON)) {
      this.handleShippingButtonClick()
    }
  }

  handleOrderNoteButtonClick = () => {
    if (this.viewMode == 'popup') {
      $el<BottomSheet>(SELECTOR_ORDER_NOTE_BOTTOM_SHEET, this).show()
    } else {
      const orderNote = $el(SELECTOR_ORDER_NOTE, this)
      this.style.setProperty(
        '--order-note-height',
        `${orderNote.scrollHeight}px`,
      )

      this.classList.toggle(CLASS_ORDER_NOTE_OPENED)
      this.classList.toggle(CLASS_SHIPPING_CALCULATOR_OPENED, false)
    }
  }

  handleShippingButtonClick = () => {
    if (this.viewMode == 'popup') {
      $el<BottomSheet>(SELECTOR_SHIPPING_CALCULATOR_BOTTOM_SHEET, this).show()
    } else {
      const shippingCalculator = $el(SELECTOR_SHIPPING_CALCULATOR, this)
      this.style.setProperty(
        '--shipping-calculator-height',
        `${shippingCalculator.scrollHeight}px`,
      )

      this.classList.toggle(CLASS_SHIPPING_CALCULATOR_OPENED)
      this.classList.toggle(CLASS_ORDER_NOTE_OPENED, false)
    }
  }

  get viewMode() {
    return this.dataset.viewMode
  }
}
